import { createContext, useContext } from "react";

/** A question asked in the app instead of the browser's confirm(), alert() and prompt(). */
export interface Ask {
  title: string;
  message?: string;
  /** The button that goes ahead. */
  confirmLabel?: string;
  cancelLabel?: string;
  /** Red, for something that can't be undone. */
  danger?: boolean;
  /** Text that has to be typed before it can go ahead, for the most consequential changes. */
  typeToConfirm?: string;
}

export interface Dialogs {
  /** True if they went ahead; false if they cancelled or closed it. */
  confirm: (ask: Ask) => Promise<boolean>;
  /** Tells them something, with one button. */
  notify: (ask: Pick<Ask, "title" | "message" | "confirmLabel">) => Promise<void>;
}

export const DialogContext = createContext<Dialogs | null>(null);

export function useDialogs(): Dialogs {
  const dialogs = useContext(DialogContext);
  if (!dialogs) throw new Error("useDialogs needs a DialogProvider above it.");
  return dialogs;
}
